import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

import { useAuth } from '../../global/contexts/auth/auth';
import { IconClose, IconLock, IconLogout, IconMenu, IconUser } from '../../common/icons';
import { bottomNav, visibleNav } from './nav-items';

import './styles/mobile-nav.css';

// Mobile chrome (hidden on desktop — portal-shell.css):
//  · a top bar with a hamburger that toggles a drop-down menu (ALL views +
//    logout, SMALL icons) for "otros aspectos" — full access via visibleNav().
//  · a fixed bottom bar with a curated PRIMARY set (Inicio · Fincas · Mis vacas
//    · Ajustes, MEDIUM icons) via bottomNav() — mobile only; the desktop
//    sidebar keeps the full nav.

export default function MobileNav() {
    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const [open, setOpen] = useState(false);

    const items = visibleNav(user?.roles_with_data);
    const tabs = bottomNav(user?.roles_with_data);

    const handleLogout = async () => {
        setOpen(false);
        await logout();
        navigate('/login?logout=true', { replace: true });
    };

    return (
        <>
            <header className="mobile-nav__topbar">
                <span className="mobile-nav__brand">
                    <span className="mobile-nav__logo-tile">
                        <img className="mobile-nav__logo" src="/cowre.png" alt="" aria-hidden="true" />
                    </span>
                    <span className="mobile-nav__wordmark">COWRE</span>
                </span>
                <button
                    type="button"
                    className="mobile-nav__hamburger"
                    onClick={() => setOpen((v) => !v)}
                    aria-label={open ? 'Cerrar menú' : 'Abrir menú'}
                    aria-expanded={open}
                >
                    {open ? <IconClose /> : <IconMenu />}
                </button>
            </header>

            {open && (
                <div className="mobile-nav__scrim" onClick={() => setOpen(false)} aria-hidden="true" />
            )}

            <div className={`mobile-nav__menu ${open ? 'mobile-nav__menu--open' : ''}`}>
                <ul className="mobile-nav__menu-list">
                    {items.map((item) => (
                        <li key={item.key}>
                            <NavLink
                                to={item.to}
                                end={item.end}
                                onClick={() => setOpen(false)}
                                className={({ isActive }) =>
                                    `mobile-nav__menu-link ${isActive ? 'mobile-nav__menu-link--active' : ''}`
                                }
                            >
                                <span className="mobile-nav__menu-icon">{item.icon}</span>
                                <span>{item.label}</span>
                            </NavLink>
                        </li>
                    ))}
                    <li>
                        <NavLink
                            to="/perfil"
                            end={false}
                            onClick={() => setOpen(false)}
                            className={({ isActive }) =>
                                `mobile-nav__menu-link ${isActive ? 'mobile-nav__menu-link--active' : ''}`
                            }
                        >
                            <span className="mobile-nav__menu-icon"><IconUser /></span>
                            <span>Mi cuenta</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink
                            to="/legal"
                            onClick={() => setOpen(false)}
                            className={({ isActive }) =>
                                `mobile-nav__menu-link ${isActive ? 'mobile-nav__menu-link--active' : ''}`
                            }
                        >
                            <span className="mobile-nav__menu-icon"><IconLock /></span>
                            <span>Privacidad y términos</span>
                        </NavLink>
                    </li>
                    <li>
                        <button type="button" className="mobile-nav__menu-logout" onClick={handleLogout}>
                            <span className="mobile-nav__menu-icon"><IconLogout /></span>
                            <span>Cerrar sesión</span>
                        </button>
                    </li>
                </ul>
            </div>

            <nav className="mobile-nav__bottom">
                {tabs.map((item) => (
                    <NavLink
                        key={item.key}
                        to={item.to}
                        end={item.end}
                        className={({ isActive }) =>
                            `mobile-nav__tab ${item.center ? 'mobile-nav__tab--center' : ''} ${isActive ? 'mobile-nav__tab--active' : ''}`
                        }
                    >
                        <span className="mobile-nav__tab-icon">{item.icon}</span>
                        <span className="mobile-nav__tab-label">{item.short}</span>
                    </NavLink>
                ))}
            </nav>
        </>
    );
}
